module.exports = __webpack_public_path__ + "img/transfer_funds.2f4b0ab4.svg";